module.exports = __webpack_public_path__ + "static/frontUserNew/img/wxGZH-2.a8372b17.png";